export const SET_LOADING = 'LOADING_SET_LOADING';

interface SetLoadingAction {
    type: typeof SET_LOADING,
    payload: boolean
}

export type LoadingActionTypes = SetLoadingAction;